import type { components } from "admination-react/api-schema";
import { getJson, sendForm, sendJson } from "./http";
import { trackSettingsWrite } from "./settingsWrites";

export type OrganisationGruendenResult = components["schemas"]["OrganisationGegruendet"];
export type OrganisationGruendenDaten = components["schemas"]["OrganisationDatenIn"];
export type Organisation = Pick<components["schemas"]["OrganisationRead"],
  "name" | keyof OrganisationGruendenDaten>;
export type OrganisationPatch = Omit<Pick<components["schemas"]["OrganisationPatch"], keyof Organisation>, "name"> & { name?: string };

export function organisationGruenden(name: string, variants: string[], daten?: OrganisationGruendenDaten): Promise<OrganisationGruendenResult> {
  return sendJson<OrganisationGruendenResult>("/organisation/gruenden", "POST", { name, variants, daten });
}

export function organisationInformationSheet(): Promise<{ vorhanden: boolean }> {
  return getJson<{ vorhanden: boolean }>("/organisation/einrichtung/informationsblatt");
}

export function uploadOrganisationInformationSheet(file: File): Promise<{ vorhanden: boolean }> {
  const form = new FormData();
  form.append("file", file, file.name);
  return trackSettingsWrite((identity) => sendForm<{ vorhanden: boolean }>("/organisation/einrichtung/informationsblatt", form, "PUT", identity));
}
